<template>
  <div class="teaser">
    <div class="teaser__teaser-info">
      <p v-for="(item, index) in items" :key="index" class="teaser__teaser-info" :class="index" v-html="item"></p>
    </div>
    <div class="teaser__teaser-actions" v-if="showActions">
      <m4-button
        v-for="(button, index) in buttons"
        tag="a"
        size="sm"
        :key="index"
        :href="button.link"
        :variant="buttonVariant(button.type)"
      >
        <m4-icon
          v-if="showIcon(button.type)"
          :icon="buttonIcon(button.type)"
          class="btn__icon btn__icon--left"
        ></m4-icon>
        {{ button.title }}
      </m4-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "M4Teaser",
  props: {
    items: {
      type: [Array, Object]
    },
    buttons: {
      type: Array
    }
  },
  computed: {
    showActions() {
      return this.buttons && this.buttons.length;
    }
  },
  methods: {
    buttonVariant: function (type) {
      const classes = {
        edit: "primary",
        delete: "danger",
        default: "info"
      };
      return classes[type] + "-outline";
    },
    buttonIcon: function (type) {
      const icons = {
        edit: "edit-alt",
        delete: "close",
        default: ""
      };
      return icons[type];
    },
    showIcon: function (type) {
      return type !== "default";
    }
  }
};
</script>
